import React from 'react';

import { WifiIcon } from '@heroicons/react/24/solid';

import { Button } from 'shared-ui';
import { AppLogo } from 'app-core';

export const NoInternet = () => {
  return (
    <div className='flex h-screen flex-col items-center justify-between'>
      <div className='pt-10'>
        <AppLogo />
      </div>
      <div className='flex grow flex-col items-center justify-center gap-2'>
        <WifiIcon className='h-10 w-10' />
        <div>No Internet Connection</div>
        <Button color='primary' onClick={() => window.location.reload()}>
          Refresh
        </Button>
      </div>
    </div>
  );
};
